export var getVariable = function getVariable(ref, variable) {
  return getComputedStyle(ref.current || document.body).getPropertyValue(variable);
};
export var getSpaceVariable = function getSpaceVariable(ref, space) {
  var _getVariable$match;
  return Number(((_getVariable$match = getVariable(ref, "--space-".concat(space)).match(/(\d*\.?\d*)(.*)/)) === null || _getVariable$match === void 0 ? void 0 : _getVariable$match[1]) || 0);
};
export var getRadiusVariable = function getRadiusVariable(ref, size) {
  var _getVariable$match2;
  return Number(((_getVariable$match2 = getVariable(ref, "--radius-".concat(size)).match(/(\d*\.?\d*)(.*)/)) === null || _getVariable$match2 === void 0 ? void 0 : _getVariable$match2[1]) || 0);
};
export var getSizeVariable = function getSizeVariable(ref, size) {
  var _getVariable$match3;
  return Number(((_getVariable$match3 = getVariable(ref, "--size-".concat(size)).match(/(\d*\.?\d*)(.*)/)) === null || _getVariable$match3 === void 0 ? void 0 : _getVariable$match3[1]) || 0);
};
export var getBorderVariable = function getBorderVariable(ref, border) {
  var _getVariable$match4;
  return Number(((_getVariable$match4 = getVariable(ref, "--border-".concat(border)).match(/(\d*\.?\d*)(.*)/)) === null || _getVariable$match4 === void 0 ? void 0 : _getVariable$match4[1]) || 0);
};
export var getFontSizeVariable = function getFontSizeVariable(ref, size) {
  var _getVariable$match5;
  return Number(((_getVariable$match5 = getVariable(ref, "--font-size-".concat(size)).match(/(\d*\.?\d*)(.*)/)) === null || _getVariable$match5 === void 0 ? void 0 : _getVariable$match5[1]) || 0);
};